<template>
    <div class="content-login">
        <loading :active.sync="loading"
                 :is-full-page="true"></loading>
        <div class="loginbox">

            <div class="logo">
                <img src="../assets/img/logo.png" alt="" />
            </div>

            <div class="logininput">
                <p><i class="fas fa-user"></i></p>
                <input id="user" v-model="username" placeholder="Username" required size="20" type="text" value="" v-on:keyup.enter="login">
                <div class="clear"></div>
            </div>

            <div class="logininput">
                <p><i class="fas fa-lock"></i></p>
                <input id="passw" v-model="password" placeholder="Password" required type="password" value="" v-on:keyup.enter="login">
                <div class="clear"></div>
            </div>

            <div class="bottom">
                <div class="loginbtn">
                    <button class="btn btn-primary" @click="login">Login</button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { RepositoryFactory } from '../repositories/RepositoryFactory';

const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'Login',
  components: { Loading },
  data() {
    return {
      loading: false,
      username: '',
      password: '',
    };
  },
  methods: {
    async login() {
      this.$Progress.start();
      this.loading = true;
      await this.$store.dispatch('login', {
        username: this.username,
        password: this.password,
      }).then((response) => {
        if (!response.data.success) { Promise.reject(response); }

        this.$Progress.finish();
        this.loading = false;
        this.$nextTick(() => {
          InstanceRepository.refetchActive();
          this.$snotify.info(this.$t('UI_LOGIN_SUCCESS'));
          this.$router.push({ name: 'home' });
        });
      }).catch((error) => {
        this.$Progress.fail();
        if (typeof error.response !== 'undefined' && error.response !== null) {
	        if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
		        this.$snotify.error(error.response.data.error_msg);
	        }
        }
        this.loading = false;
      });
    },
  },
};
</script>
